import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

export interface TagOption {
  name: string;
  color: string;
}

interface UseOpportunityFiltersReturn {
  uniqueTags: TagOption[];
  loading: boolean;
}

export function useOpportunityFilters(): UseOpportunityFiltersReturn {
  const { user } = useAuth();
  const [uniqueTags, setUniqueTags] = useState<TagOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user?.account?.id || !supabase) return;

    const fetchFilters = async () => {
      if (!supabase) return;

      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('account_tags')
          .select('name, color')
          .eq('account_id', user.account.id)
          .eq('is_active', true)
          .order('name', { ascending: true });

        if (error) throw error;

        setUniqueTags(data || []);
      } catch (err) {
        console.error('Erro ao buscar tags:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFilters();
  }, [user?.account?.id]);

  return { uniqueTags, loading };
}
